import React from 'react';
import { AlertAppearance as IAlertAppearance } from '@cvent/carina/components/Alert/AlertBase';
import { UserAlert } from '@cvent/carina/components/Alert/UserAlert';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';
import { createPortal } from 'react-dom';
import { CSSObject } from '@emotion/react';

export enum operations {
  requestSuccess = 'REQUEST_SENT',
  requestFailure = 'REQUEST_FAILED',
  acceptSuccess = 'ACCEPT_SUCCESS',
  acceptFailure = 'ACCEPT_FAILURE',
  declineSuccess = 'DECLINE_SUCCESS',
  declineFailure = 'DECLINE_FAILURE',
  cancelSuccess = 'CANCEL_SUCCESS',
  cancelFailure = 'CANCEL_FAILURE',
  removeSuccess = 'REMOVE_SUCCESS',
  removeFailure = 'REMOVE_FAILURE'
}

const successBannerStyles = (): Record<string, CSSObject> => ({
  alert: {
    position: 'fixed',
    top: 20,
    zIndex: 10000
  },
  desktopAlert: {
    left: '50%',
    transform: 'translate(-50%)'
  },
  mobileAlert: {
    marginLeft: -8
  }
});

type ConnectionAlertProps = {
  onDismiss: () => void;
  type: operations;
};

const ConnectionAlert = ({ onDismiss, type }: ConnectionAlertProps): JSX.Element => {
  const { alert, desktopAlert, mobileAlert } = successBannerStyles();
  const { translate } = useTranslate();
  const { isMobile } = useBreakpoints();
  const deviceStyles = isMobile ? mobileAlert : desktopAlert;

  let content;
  let appearance: IAlertAppearance = 'success';
  switch (type) {
    case operations.requestSuccess:
      content = translate('Attendee-Connection-Message-Request-Successful');
      break;
    case operations.requestFailure:
      content = translate('Attendee-Connection-Message-Request-Failure');
      appearance = 'danger';
      break;
    case operations.acceptSuccess:
      content = translate('Attendee-Connection-Message-Accept-Successful');
      break;
    case operations.acceptFailure:
      content = translate('Attendee-Connection-Message-Accept-Failure');
      appearance = 'danger';
      break;
    case operations.declineSuccess:
      content = translate('Attendee-Connection-Message-Decline-Successful');
      break;
    case operations.declineFailure:
      content = translate('Attendee-Connection-Message-Decline-Failure');
      appearance = 'danger';
      break;
    case operations.cancelSuccess:
      content = translate('Attendee-Connection-Message-Cancel-Successful');
      break;
    case operations.cancelFailure:
      content = translate('Attendee-Connection-Message-Cancel-Failure');
      appearance = 'danger';
      break;
    case operations.removeSuccess:
      content = translate('Attendee-Connection-Message-Remove-Successful');
      break;
    case operations.removeFailure:
      content = translate('Attendee-Connection-Message-Remove-Failure');
      appearance = 'danger';
      break;
    default:
    // empty intended
  }

  return createPortal(
    <div css={[alert, deviceStyles]}>
      <UserAlert
        appearance={appearance}
        content={content}
        dismissible
        onDismiss={onDismiss}
        isPositionFixed={false}
        dismissInterval={4000}
        testID="connections-alert"
      />
    </div>,
    document.getElementsByTagName('body')[0]
  );
};

export default ConnectionAlert;
